// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(backgroundColorOpt, headingColorOpt, colorOpt, blockBackgroundColorOpt, param) {
  var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme__Color$PrezzeeRibbon.lilac400;
  var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme__Color$PrezzeeRibbon.gray800;
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.gray600;
  var blockBackgroundColor = blockBackgroundColorOpt !== undefined ? blockBackgroundColorOpt : Theme__Color$PrezzeeRibbon.lilac100;
  return {
          backgroundColor: backgroundColor,
          headingColor: headingColor,
          color: color,
          blockBackgroundColor: blockBackgroundColor
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
